import React from 'react'
import {
  FormControl,
  FormControlLabel as MuiFormControlLabel,
  FormGroup,
  FormLabel,
} from '@mui/material'
import type {
  FormControlLabelProps as MuiFormControlLabelProps,
  ThemeOptions,
} from '@mui/material'
import styled from '@emotion/styled'
import { Text } from '../Text'
import { colors } from '../../tokens/colors'

const SubLabel = styled(Text)`
  display: block;
  line-height: 1.5;
`

const Label = styled.div`
  margin: 6px 0;
`

const FormControlLabelWithSubLabel = styled(MuiFormControlLabel, {
  shouldForwardProp: (prop) => prop !== 'withSublabel',
})<{
  withSublabel: boolean
}>`
  align-items: ${({ withSublabel }) =>
    withSublabel ? 'flex-start' : 'center'};
`

type FormControlLabelProps = MuiFormControlLabelProps & {
  sublabel?: React.ReactNode
}

const FormControlLabel: React.FC<FormControlLabelProps> = ({
  label,
  sublabel,
  ...props
}) => (
  <FormControlLabelWithSubLabel
    withSublabel={Boolean(sublabel)}
    label={
      sublabel ? (
        <Label>
          {label}
          <SubLabel variant='caption' color='textSecondary'>
            {sublabel}
          </SubLabel>
        </Label>
      ) : (
        label
      )
    }
    {...props}
  />
)

export { FormControl, FormControlLabel, FormGroup, FormLabel }

export type { FormControlLabelProps }

export const formLabelThemeOverrides: ThemeOptions['components'] = {
  MuiFormLabel: {
    styleOverrides: {
      root: {
        color: colors.text.primary,
        // eslint-disable-next-line
        '&.Mui-focused': {
          color: colors.text.primary,
        },
      },
    },
  },
}
